<template>
  <!-- <div class="card" v-for="item in must" :key="item.insuranceId"> -->
  <div class="card">
    <div v-if="index" class="card-topline" style="border-top: 1px solid #F5f5f5"></div>
    <div v-if="!insuranceId" class="insure-status">
      <span
        :class="['status', item.status ? 'status0' : 'status1']"
        style="
          width: 47px;
          height: 18px;
          line-height: 18px;
          text-align: center;
          font-size: 13px;
        "
        >{{ item.status ? '待完善' : '已完善' }}</span
      >
    </div>
    <div class="top">
      <div class="top-left">
        <div class="img">
          <img :src="item.insurancePicUrl" />
        </div>
        <div class="title">
          <div class="name">{{ item.insuranceName }}</div>
          <div class="status">{{ item.insuranceCategoryName }}</div>
        </div>
      </div>
      <div class="top-right">
        <div class="btn" @click="handleComplete(item)">
          <img class="btn-bgi" src="../img/button_bg.png" />
          <span class="text">{{ item.status ? '去完善' : '续保' }}</span>
          <img class="btn-shadow" src="../img/btn_shadow.png" />
        </div>

        <div class="upload" @click="handleUpload(item)">
          <span>{{ item.status ? '上传已购保单' : '查看保单' }}</span>
          <img src="../img/right.png" />
        </div>
      </div>
    </div>

    <div class="bottom" :ref="'desc' + item.insuranceId">
      <div>保险要求：</div>
      <div class="desc" v-html="item.insuranceDesc"></div>
      <div class="show-more" style="text-align: center">
        <van-icon name="arrow-down" @click="handleMore($event)" />
      </div>
    </div>
  </div>
</template>

<script>
import { ApiGetInsurDetail } from '@/api/insurance';
export default {
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    userId() {
      return this.$store.state.account.userId;
    },
    storeId() {
      return this.$store.state.account.storeId;
    },
    plazaId() {
      return this.$store.state.account.plazaId;
    },
  },
  data() {
    return {
      backgroundImage: {
        btn: 'url(' + require('../img/button_bg.png') + ')',
      },
    };
  },
  methods: {
    handleMore(e) {
      console.log(e);
      let path = e.path || (e.composedPath&&e.composedPath())
      console.log(path);
      let actionDom = path[0];
      let descDom = path[2].children[1];
      let domInfo = window.getComputedStyle(descDom, null);
      if (domInfo.webkitLineClamp == '3') {
        descDom.style.webkitLineClamp = '10';
        actionDom.style.transform = 'rotateZ(180deg)';
      } else {
        descDom.style.webkitLineClamp = '3';
        actionDom.style.transform = 'rotateZ(0deg)';
      }
    },
    handleComplete(item) {
      this.$router.push({
        path: '/insure_linkPage',
        query: {
          pageType: 'insure_complete',
          caseCode: item.caseCode,
        },
      });
    },
    handleUpload(item) {
      // 上传保单 | 查看保单
      if (item.status == 0 && item.perfectMode == 1) {
        this.$router.push({
          path: '/insure_linkPage',
          query: {
            pageType: 'insure_detail',
            insureNum: item.insureNum,
          },
        });
        return;
      }
      let data = {
        insuranceId: item.insuranceId,
        plazaId: this.plazaId,
        storeId: this.storeId,
        source: 1,
      };
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0,
      });

      ApiGetInsurDetail(data).then((res) => {
        this.$toast.clear();
        if (res) {
          // 查看保单
          this.$router.push({
            path: '/insure_detail',
            query: {
              insuranceId: item.insuranceId,
            },
          });
        } else {
          // 上传保单
          this.$router.push({
            path: '/insure_edit',
            query: {
              insuranceId: item.insuranceId,
              insuranceName: item.insuranceName,
              insuranceDesc: item.insuranceDesc,
            },
          });
        }
      });
    },
  },
  mounted() {
    setTimeout(() => {
      for (const key in this.$refs) {
        let dom = this.$refs[key];
        let domInfo = window.getComputedStyle(dom, null);
        let lineHeight = domInfo.lineHeight.slice(0, -2);

        let descDom = dom.children[1];
        let actionDom = dom.children[2];

        let descHeight = descDom.clientHeight;
        if (lineHeight * 3 > descHeight) {
          actionDom.style.display = 'none';
        } else {
          descDom.style.webkitLineClamp = '3';
        }
      }
    }, 400);
  },
};
</script>

<style lang="less" scoped>
.card-topline {
  height: 1px;
  position: absolute;
  left: 12px;
  right: 12px;
  top: 0;
}
.card {
  background: #ffffff;
  // border-radius: 8px;
  padding: 16px 12px;
  // margin-bottom: 12px;
  // border-top: 1px solid #e7e7e7;
  position: relative;

  .insure-status {
    padding: 0px 5px 12px;
    text-align: right;
    .status {
      display: inline-block;
    }
    .status0 {
      color: #fc9127;
      background: #fdf6e9;
    }
    .status1 {
      color: #65b2f6;
      background: #e9f8fd;
    }
  }
  .top {
    display: flex;
    justify-content: space-between;
    .top-left {
      display: flex;
      .img {
        width: 56px;
        height: 56px;
        border-radius: 4px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .title {
        margin-left: 8px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .name {
          font-size: 16px;
          font-weight: 600;
          color: #111111;
        }
        .status {
          margin-top: 8px;
          font-size: 12px;
          font-weight: 400;
          color: #999999;
        }
      }
    }
    .top-right {
      text-align: center;

      .btn {
        width: 94px;
        height: 32px;
        position: relative;
        z-index: 1;
        .btn-bgi {
          width: 100%;
          height: 100%;
        }
        .text {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
        }
        .btn-shadow {
          position: absolute;
          width: 100%;
          height: 100%;
          left: 0;
          top: 45%;
        }
      }
      .upload {
        position: relative;
        z-index: 10;
        margin-top: 8px;
        font-size: 12px;
        font-weight: 400;
        color: #999999;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        img {
          margin-right: 4px;
          width: 12px;
          height: 12px;
        }
      }
    }
  }
  .bottom {
    margin-top: 15px;
    font-size: 12px;
    font-weight: 400;
    color: #666666;
    background: #f5f7f8;
    padding: 8px;
    border-radius: 4px;
    line-height: 20px;
    white-space: pre-line;
    .desc {
      overflow: hidden;
      display: -webkit-box;
      text-overflow: ellipsis;
      // -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      transition: all 0.25 ease;
    }
    .show-more {
      margin-top: 5px;
      .van-icon {
        display: inline-block;
        width: 32px;
        height: 14px;
        background-color: #eaebec;
        color: #bebebe;
        border-radius: 8px;
        padding-top: 2px;
      }
    }
  }
}
</style>